import { request as getRequest } from './reducers/get';
import { request as updateRequest } from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default {
    COUNTRY_GET_REQUEST: getRequest,
    COUNTRY_UPDATE_REQUEST: updateRequest,
};
